import _createPageConfig from '../../../lib/base/createPageConfig';
import PageClass from './user.user';

 var $g_fns_data = {
		get _userdata(){
			return wx.Util.prepareUserData(this, {

			}, ['id','name','email','phone','avatarUrl','_key']);
		}
}; 


import '../../wrapper/wrapper';
import '../../row/css/row.css'; 
import '../../image/image'; 
import '../../image/css/image.css'; 
import '../../page/page'; 
import '../../page/css/page.css'; 
import '../../commonOperation/commonOperation'; 
import '../../icon/css/icon.css'; 
import '../../toptips/toptips'; 
import '../../toptips/css/toptips.css'; 
import '../../restData/restData'; 
import '../../wxApi/wxApi'; 
var methods = {

 $imageUrlFn_image1: function({data,$row,$comp,params,$page,props}){
 return data.current.avatarUrl ;
}

}
var template = [
	[
		{
			"cls":wx.compClass('$UI/wxsys/comps/restData/restData'),
			"props":{
				"schema":{
					"limit":20,
					"orderBy":[],
					"type":"array",
					"items":{
						"type":"object",
						"props":{
							"id":{
								"define":"id",
								"label":"id",
								"type":"string",
								"extType":"String"
							},
							"name":{
								"define":"name",
								"label":"姓名",
								"type":"string",
								"extType":"String"
							},
							"email":{
								"define":"email",
								"label":"邮箱",
								"type":"string",
								"extType":"String"
							},
							"phone":{
								"define":"phone",
								"label":"手机",
								"type":"string",
								"extType":"String"
							},
							"avatarUrl":{
								"define":"avatarUrl",
								"label":"头像",
								"type":"string",
								"extType":"String"
							},
							"_key":{
								"type":"string"
							}
						},
						"key":"_key",
						"fns":$g_fns_data
					},
					"id":"data",
					"keyItems":"_key"
				},
				"$events":{
					"customRefresh":"customRefresh"
				},
				"options":{
					"calcTotal":"",
					"distinct":false,
					"className":"/uaa/user",
					"autoMode":"",
					"checkRange":"",
					"enableCustomIdValue":false,
					"tableName":"user",
					"confirmRefreshText":"",
					"allowEmpty":false,
					"feature":{
						"filter":true,
						"subquery":true,
						"distinct":true,
						"paging":true,
						"sort":true,
						"join":true,
						"fields":true,
						"params":false
					},
					"confirmDeleteText":"",
					"confirmRefresh":false,
					"primaryColumns":[
						"id"
					],
					"isReference":false,
					"restResource":"class",
					"isMain":false,
					"directDelete":true,
					"serviceName":"uaa",
					"defSlaves":[],
					"confirmDelete":true,
					"enableContextReadonly":true,
					"checkMode":"",
					"isAllColumns":true,
					"multiplePrimary":false,
					"idColumn":"id"
				},
				"id":"data",
				"filters":{}
			}
		}
	],
	{
		"cls":wx.compClass('$UI/wxsys/comps/page/page'),
		"props":{
			"$events":{
				"load":"pageLoad"
			},
			"id":"page"
		}
	},
	{
		"cls":wx.compClass('$UI/wxsys/comps/wxApi/wxApi'),
		"props":{
			"id":"wxapi"
		}
	},
	{
		"cls":wx.compClass('$UI/wxsys/comps/commonOperation/commonOperation'),
		"props":{
			"id":"commonOperation1"
		}
	},
	{
		"cls":wx.compClass('$UI/wxsys/comps/image/image'),
		"props":{
			"$urlFn":"$imageUrlFn_image1",
			"id":"image1"
		}
	},
	{
		"cls":wx.compClass('$UI/wxsys/comps/wrapper/wrapper'),
		"props":{
			"id":"label4"
		}
	},
	{
		"cls":wx.compClass('$UI/wxsys/comps/wrapper/wrapper'),
		"props":{
			"id":"label5"
		}
	},
	{
		"cls":wx.compClass('$UI/wxsys/comps/toptips/toptips'),
		"props":{
			"id":"__toptips__"
		}
	}
];
var dependTree = {
	"page":{
		"__toptips__":{
			"depends":["__toptips__.show","__toptips__.compid"],
			"__auto1":{
				"depends":["__toptips__.msgs","__toptips__.items[].typeClass","__toptips__.items[].show","__toptips__.items[].message"]
			}
		},
		"row1":{
			"depends":[],
			"col2":{
				"depends":[],
				"label1":{
					"depends":["data.current.name"]
				}
			},
			"col1":{
				"depends":[],
				"image1":{
					"depends":["image1.url","image1.compid"]
				}
			}
		},
		"inVisibleCompContainer1":{
			"depends":[]
		},
		"depends":["page.compid","__pageid__"],
		"row3":{
			"depends":[],
			"col8":{
				"depends":[]
			},
			"col6":{
				"depends":[],
				"iconEmail":{
					"depends":[]
				}
			},
			"col7":{
				"depends":[],
				"label3":{
					"depends":["data.current.email"]
				}
			}
		},
		"row2":{
			"depends":[],
			"col4":{
				"depends":[],
				"label2":{
					"depends":["data.current.phone"]
				}
			},
			"col5":{
				"depends":[]
			},
			"col3":{
				"iconphoneNumber":{
					"depends":[]
				},
				"depends":[]
			}
		},
		"row5":{
			"col14":{
				"depends":[]
			},
			"col13":{
				"label5":{
					"depends":["label5.compid","__pageid__"]
				},
				"depends":[]
			},
			"depends":[],
			"col12":{
				"iconLogout":{
					"depends":[]
				},
				"depends":[]
			}
		},
		"row4":{
			"depends":[],
			"col9":{
				"depends":[],
				"iconPwd":{
					"depends":[]
				}
			},
			"col11":{
				"depends":[]
			},
			"col10":{
				"label4":{
					"depends":["label4.compid","__pageid__"]
				},
				"depends":[]
			}
		}
	}
}
export function createPageConfig(){
	return _createPageConfig(PageClass, template, methods, {"navigationBarTitleText":"个人信息"},{}, dependTree)
}
export function createPage(owner, pageid, props){
	var page = new PageClass(owner, props);
	page.$init(template, methods, pageid);
	return page;
}
